import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
// import './assets/dist/leaflet.css';
import './assets/dist/animate.min.css';
import './assets/css/productfont.css';
import "./assets/css/common.css";
import "./assets/css/template1.scss";
import "./assets/css/template2.scss";
// import "./assets/css/template3.scss";
import "./assets/css/fonts.css";
import "./assets/css/backgroundImage.css";
import "./assets/css/template2menusecondstyles.css";
import "./assets/css/orangetheme.scss";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import configureStore from './redux/store/configureStore';

import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import OffileDb from './config/pouchDB';
import cordovaConfig from './config/cordovaConfig';
import ReactGA from './config/ReactGA';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import ErrorBoundary from './components/ErrorBoundary';
import moment from 'moment';
import { getLsData, setLsData, removeLsData } from './service/lsencryption';
import { db } from "./service/firebase";

const themesChanges = {
  template1: './index.css',
  template2: './index.css',
  template3: './index.css',
};

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'museo_sans300',
      'museo_sans500',
      'museo_sans900',
    ].join(','),
  },
});



const store = configureStore();

const startApp = () => {
  //const CHOSEN_TemplateID = store.getState().storeState.templateID;
  const CHOSEN_TemplateID=getLsData('templateID')
  const colorval = getLsData('colorTheme') != null ? getLsData('colorTheme') : 1
  var CHOSEN_THEME = CHOSEN_TemplateID == 1 || CHOSEN_TemplateID == null || CHOSEN_TemplateID == 'null' ? 'template1' : (CHOSEN_TemplateID == 2 ? "template2" : "template3");
  const styleNode = document.createComment('inject-styles-here');
  document.head.insertBefore(styleNode, document.head.firstChild);
  document.getElementsByTagName("body")[0].setAttribute("data-colorTheme", colorval == 1 ? 'light' : 'dark');

  ReactDOM.render(
    <ErrorBoundary>
      <ThemeSwitcherProvider insertionPoint="inject-styles-here" defaultTheme={CHOSEN_THEME} themeMap={themesChanges}>
        <React.StrictMode>
          <I18nextProvider i18n={i18n}>
            <Provider store={store}>
              <ThemeProvider theme={theme}>
                <App />
                <div className="offline-msg">You are in offline mode.</div>
              </ThemeProvider>
            </Provider>
          </I18nextProvider>
        </React.StrictMode>
      </ThemeSwitcherProvider>
    </ErrorBoundary>
    ,
    document.getElementById('root')
  );
  setTimeout(function(){
    clearOfflineDataInADay();
  },1000)
}

function clearOfflineDataInADay(){
  let today = moment(new Date()).format("DD-MM-YYYY");
  let dataClearedDate = getLsData('datacleareddate');
  if(dataClearedDate==null){
    setLsData('datacleareddate', moment().add(1, 'd').format("DD-MM-YYYY"));
    dataClearedDate = getLsData('datacleareddate');
  }

  if(dataClearedDate == today){
    OffileDb.deleteDatabse();
    console.log("data has been cleared");
    setLsData('datacleareddate', moment().add(1, 'd').format("DD-MM-YYYY"));
  }
}

function onResume() {
  var sessionId = Math.random().toString(36).replace('0.','');
  console.log("onResume : ", getLsData("CommunityId"));
  if(getLsData('sessionStart') == undefined){
    setLsData('sessionStart',moment().unix());
    setLsData('sessionId',sessionId);
  }else if (getLsData('sessionEnd') != undefined){
    var currentTime = moment().unix()
    var milis = moment.duration(moment(getDate(moment().unix()), "HH:mm:ss").diff(moment(getDate(getLsData('sessionEnd')), "HH:mm:ss")));
    var minutesDiff = Math.floor(milis / 60000);
    if(minutesDiff > 5 ){
      setLsData('sessionStart',currentTime);
      sessionId = Math.random().toString(36).replace('0.','');
      setLsData('sessionId',sessionId);
      removeLsData('module_data');
    }
  }
  // alert('resumed');
  setLsData('BotInnit', "false");
  //FCMPluginNG.onNotification( onNotificationCallback(data), successCallback(msg), errorCallback(err) )
  //Here you define your application behaviour based on the notification data.

}

function getDate(timestamp){
  // var currentTimeC = moment().unix()
  let date = new Date(timestamp * 1000);
  var hours = date.getHours();
  var minutes = "0" + date.getMinutes();
  var seconds = "0" + date.getSeconds();
  var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
  var currentTimeInFormat = formattedTime;
  return currentTimeInFormat;
}

function onPause() {
  console.log("onPause", getLsData("CommunityId"));
  var sessionStart = getLsData('sessionStart');
  var sessionEnd = moment().unix();
  setLsData('sessionEnd',sessionEnd);
  const userId = getLsData("obj").userId;
  const sessionId = getLsData('sessionId');
  const date = new Date();
  const formatedDate = date.getDate()+'-'+(date.getMonth()+1)+'-'+date.getFullYear();

  const sessionData = {
    start: sessionStart,
    end : sessionEnd
  }
  const CommunityId = getLsData("CommunityId");
  const path = CommunityId+'/session_data/'+userId+'/'+formatedDate+'/'+sessionId;
  db.ref(path).child('session_time').set(sessionData);
  
  if(getLsData('module_data')){
    var module_data = getLsData('module_data')
    module_data.end = sessionEnd
    const date = new Date();
    const formatedDate = date.getDate()+'-'+(date.getMonth()+1)+'-'+date.getFullYear();
    const path = CommunityId+'/session_data/'+userId+'/'+formatedDate+'/'+sessionId;
    // db.ref(path).child('module_data').push(module_data);
  }

  if(window.TTS){
    window.TTS.speak("");
  }
}

function onOffline() {
  // Handle the offline event
  console.log("device is in offline");
  document.querySelector('.offline-msg').style.display = 'block';
}

function checkNetwork() {
  if (window.cordova && window.navigator) {
    var networkState = window.navigator.connection.type;
    if (networkState == window.Connection.NONE) {
      document.querySelector('.offline-msg').style.display = 'block';
    }
  }
}

function onOnline() {
  // Handle the online event
  console.log("device is in online");
  document.querySelector('.offline-msg').style.display = 'none';
}
//ReactGA.initialize()
if (!window.cordova) {
  startApp()
  OffileDb.setDatabase()
  ReactGA.webappInit();
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      onPause()
    } else {
      onResume()
    }
 }); 
} else {
  document.addEventListener('deviceready', () => {
    startApp();
    OffileDb.setDatabase()
    cordovaConfig.init()
    checkNetwork();
    if(window.cordova.InAppBrowser){
      window.open = window.cordova.InAppBrowser.open;
    }
    ReactGA.webappInit()

    if(window.cordova && window.cordova.plugins.diagnostic){
      window.cordova.plugins.diagnostic.requestRemoteNotificationsAuthorization({
        successCallback: function(){
            console.log("Successfully requested remote notifications authorization");
        },
        errorCallback: function(err){
           console.error("Error requesting remote notifications authorization: " + err);
        },
        types: [
          window.cordova.plugins.diagnostic.remoteNotificationType.ALERT,
          window.cordova.plugins.diagnostic.remoteNotificationType.SOUND,
          window.cordova.plugins.diagnostic.remoteNotificationType.BADGE
        ],
        omitRegistration: false
      });
    }

    if(window.FirebasePlugin){
      window.FirebasePlugin.onTokenRefresh(function(fcmToken) {
        console.log("fcmToken", fcmToken);
        if(fcmToken){
          setLsData('fcmToken', fcmToken);
        }
      }, function(error) {
          console.error(error);
      });

      window.FirebasePlugin.hasPermission(function(hasPermission){
        console.log("Permission is " + (hasPermission ? "granted" : "denied"));
        if(!hasPermission){
          window.FirebasePlugin.grantPermission(function(hasPermission){
            console.log("Permission was " + (hasPermission ? "granted" : "denied"));
          });
        }
      });

    }
    navigator.splashscreen.hide();
    document.addEventListener("resume", onResume, false);
    document.addEventListener("pause", onPause, true);
    document.addEventListener("offline", onOffline, false);
    document.addEventListener("online", onOnline, false);
  }, false);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
